<template>
<div>  
    <!-- published Section -->
    <section class="page-section bg-color-dynamic" id="publishedsection">
        <!-- muncul pas gede aja -->
        <div class="container d-sm-none d-lg-block d-none d-md-block">
            <h1 class="text-center mt-0 section-title">
                {{ $t('textPublishedBy1') }}
            </h1>
            <hr class="divider my-4" style="visibility:hidden;margin:0.5rem!important;">
            <div dir="ltr" class="d-flex flex-row flex-wrap justify-content-center align-items-center" style="gap: 0.25rem;">
                <a v-for="[index, pub] of lists.entries()" :href="pub.url" target="_blank">                    
                    <img v-lazy="pub.img" alt="pub" :class="index == 4 ? 'detik-special' : ''"/>
                    <span v-lazy:background-image="pub.img"></span>
                </a>
            </div>
        </div>

        <!-- muncul pas kecil aja -->
        <div class="container d-block d-md-none">
            <h1 class="text-center mt-0 section-title">
                {{ $t('textPublishedBy1') }}
            </h1>
            <div dir="ltr" class="d-flex flex-row flex-wrap justify-content-center align-items-center" style="gap: 0.25rem; margin-top: 3rem;">
                <a v-for="listIndex in listsMobileOnlyIndex" :href="lists[listIndex].url" target="_blank" class="d-inline-flex flex-row justify-content-center">                    
                    <img v-lazy="lists[listIndex].img" alt="pub" :class="listIndex == 4 ? 'detik-special' : ''"/>
                    <span v-lazy:background-image="lists[listIndex].img"></span>
                </a>
            </div>
        </div>
        <div class="d-flex flex-row justify-content-center" style="margin: 2rem 0;">
            <span class="many-more text-roboto" v-t="{path: 'textPublishedBy2'}"></span>
        </div>
    </section>
</div>
</template>

<script>
import { createImageObject } from '@/utils/utils';

import imgPub1 from '@/assets/img/publishedby/pub1.png';
import imgPub2 from '@/assets/img/publishedby/pub2.png';
import imgPub3 from '@/assets/img/publishedby/pub3.png';
import imgPub4 from '@/assets/img/publishedby/pub4.png';
import imgPub5 from '@/assets/img/publishedby/pub5.png';
import imgPub6 from '@/assets/img/publishedby/pub6.png';
import imgPub7 from '@/assets/img/publishedby/pub7.png';
import imgPub8 from '@/assets/img/publishedby/pub8.png';
import imgPub9 from '@/assets/img/publishedby/pub9.png';
import imgPub10 from '@/assets/img/publishedby/pub10.png';
import imgPub11 from '@/assets/img/publishedby/pub11.png';
import imgPub12 from '@/assets/img/publishedby/pub12.png';
import imgPub13 from '@/assets/img/publishedby/pub13.png';
import imgPub14 from '@/assets/img/publishedby/pub14.png';

export default {
   name: 'PublishedSection',
   data() {
    return {
        lists: [
            {
                img: createImageObject(imgPub1),
                url: 'https://learn-quran.co/link/pubAmustTajwid2018',
            },
            {
                img: createImageObject(imgPub2),
                url: 'https://learn-quran.co/link/pubBekrafArchive2018',
            },
            {
                img: createImageObject(imgPub3),
                url: 'https://learn-quran.co/link/pubDiginationDepokToWorld',
            },
            {
                img: createImageObject(imgPub4),
                url: 'https://learn-quran.co/link/pubDreamLQTafsirInovasi',
            },
            {
                img: createImageObject(imgPub5),
                url: 'https://learn-quran.co/link/pubDetikVideoBekrafSyariah',
            },
            {
                img: createImageObject(imgPub6),
                url: 'https://learn-quran.co/link/pubGomuslimArchive2016',
            },
            {
                img: createImageObject(imgPub7),
                url: 'https://learn-quran.co/link/pubIslampos67381',
            },
            {
                img: createImageObject(imgPub8),
                url: 'https://learn-quran.co/link/pubKompasBelajarVirtual',
            },
            {
                img: createImageObject(imgPub9),
                url: 'https://learn-quran.co/link/pubMNCLiveChatYouTube',
            },
            {
                img: createImageObject(imgPub10),
                url: 'https://learn-quran.co/link/pubKontanPressReleaseArchive2019',
            },
            {
                img: createImageObject(imgPub11),
                url: 'https://learn-quran.co/link/pubRepublikaLearnQuranSmartphone',
            },
            {
                img: createImageObject(imgPub12),
                url: 'https://learn-quran.co/link/pubRumahMillennialsArchive2018',
            },
            {
                img: createImageObject(imgPub13),
                url: 'https://learn-quran.co/link/pubSWABekrafDeureuham2019',
            },
            {
                img: createImageObject(imgPub14),
                url: 'https://learn-quran.co/link/pubTeknoJurnalRamadhanBeasiswa',
            },
        ],
        listsMobileOnlyIndex: [0, 1, 4, 7, 10, 12, 8],
    }
  },
    mounted() {
       this.$nextTick(() => {
            // alert('published section finish loaded')
            this.$emit('isPartnerSection', 'partnerSectionActive')
        })
    },
}
</script>

<style scoped>

.detik-special {
    max-height: 2.5rem;
}
@media (min-width: 320px) {
    .detik-special {
        max-height: 2.5rem;
    }
}

.rounded-lg {
    border-radius: .5rem!important;
}
img {
    max-height:5rem;    
    /* max-height: 3.7rem; */
    max-width: 100%;
    transition: 0.3s;
}

.col-fix-width {
    /* min-width: max-content; */
}

img:hover {    
    opacity: 0.5;
}

.section-title {
    font-family: 'QuattrocentoRegular', 'Rubik', sans-serif;
    /* font-weight: 0!important; */
    color:#053448;
}
.pub-half {
    max-width: 45%!important;
}
.many-more {
    font-weight: 400;
    font-size: 1.75rem;
    color: #053448;
}

#publishedsection {
    padding-bottom: 0.1rem!important;
}

.no-padding-col {
    padding: unset;
}

.bg-color-dynamic {
    --afterclick-bg-color: white;
    background-color: var(--afterclick-bg-color) !important;

}
body.dark .bg-color-dynamic {
  --afterclick-bg-color: #dcdcdc!important;
}

body.force-dark .bg-color-dynamic {
  --afterclick-bg-color: #dcdcdc!important;
}

@media (min-width: 992px) {
    .many-more {
        font-size: 1.5rem;
    }
}
</style>
